import { GET_REPORT } from './getReport';
import { PULL_GROUP_ITEMS } from './pullGroupItems';
import { PULL_GROUPS_SUMMARY } from './pullGroupsSummary';

export const bpfReportAPI = {
  getReport: GET_REPORT,
  groupItems: PULL_GROUP_ITEMS,
  groupsSummary: PULL_GROUPS_SUMMARY,
};
